import { element, number, object, oneOfType, string } from 'prop-types'
import { isValidElement } from 'react'
import { Asset } from '@opallabs/cassini'
import { decorateServiceName } from '@opallabs/wormhole'
import { ConnectedAvatar } from '../../Avatar/ConnectedAvatar'
import { kuiperClassNames } from '../../utils'
import { iconRenderer } from './helpers'

import './styles.scss'

const TokenIcon = ({
  color,
  icon,
  iconAssetReference,
  iconSystemName,
  style,
  styleOverrides = {},
  userId,
}) => {
  if (isValidElement(icon)) {
    return icon
  }

  if (userId) {
    return (
      <div className={kuiperClassNames('tokenIcon')} aria-hidden>
        <ConnectedAvatar icon={icon} userId={userId} size={16} />
      </div>
    )
  }

  if (iconAssetReference) {
    const transforms = { height: 14, width: 14, fit: 'cover' }
    return (
      <div className={kuiperClassNames('tokenIcon')} aria-hidden>
        <Asset assetReference={iconAssetReference} transforms={transforms} />
      </div>
    )
  }

  if (icon && !iconSystemName) {
    return (
      <div
        aria-hidden
        className={kuiperClassNames('tokenIcon')}
        css={styleOverrides}
      >
        {iconRenderer(icon, color, style)}
      </div>
    )
  }

  const isChannelIcon = icon || (!icon && iconSystemName)
  if (isChannelIcon) {
    const decoratedIconName = decorateServiceName(
      icon || iconSystemName,
      null,
      true,
      true
    )
    return (
      <div className={kuiperClassNames('tokenIcon')} aria-hidden>
        {iconRenderer(decoratedIconName, color, style)}
      </div>
    )
  }

  return null
}

TokenIcon.defaultProps = {
  style: {},
}

TokenIcon.propTypes = {
  color: string,
  icon: oneOfType([element, string]),
  iconAssetReference: object,
  iconSystemName: string,
  style: object,
  styleOverrides: object,
  userId: oneOfType([number, string]),
}

export default TokenIcon
